import Vue from 'vue'
import VueRouter from 'vue-router'
// 自定义的工具库，用于操作 Cookie
import cookieUtil from '@/common/cookie-util'
import store from '@/store'
import layoutView from '@/views/main/layout-view/index.vue'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    meta: {
      title: '可视化',
      hideInMenu: true
    },
    component: () => import('@/views/home/visualization.vue')
  },
  {
    path: '/login',
    meta: {
      title: '登录页',
      hideInMenu: true
    },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/userInfo',
    meta: {
      title: '个人信息',
      icon: 'home'
    },
    component: layoutView,
    children: [{
      path: '/userInfo',
      meta: {
        hideInMenu: true,
        title: '个人信息'
      },
      component: () => import('@/views/userInfo')
    }]
  },
  // {
  //   path: '/pages/supplierManagement/information/add',
  //   name: 'supplierManagementAdd',
  //   meta: {
  //     title: '供应商信息添加',
  //     hideInMenu: true
  //   },
  //   component: () => import('@/views/pages/supplierManagement/information/add')
  // },
  // {
  //   path: '/pages/supplierManagement/information/details',
  //   name: 'supplierManagementDetails',
  //   meta: {
  //     title: '供应商信息详情',
  //     hideInMenu: true
  //   },
  //   component: () => import('@/views/pages/supplierManagement/information/details')
  // },
  // {
  //   path: '/pages/systemAudit/details',
  //   name: 'systemAuditDetails',
  //   meta: {
  //     title: '供应商审核详情',
  //     hideInMenu: true
  //   },
  //   component: () => import('@/views/pages/systemAudit/details')
  // },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // const token = cookieUtil.getToken()
  const token = localStorage.getItem("admin_token")
  if (token) {
    store.dispatch('app/getMenuList')
  }
  if (!token && to.path !== '/login' && !to.meta.whiteRoute) {
    next('/login')
  } else if (token && to.path === '/login') {
    store.dispatch('app/getMenuList')
  } else if (token && to.path === '/') {
    // next('/system/dept')
    next('/supplierManagement/information')
  } else {
    next()
  }
})

export default router
